// ActiveRecalcBadge — "recalculation running" pill in the top bar (task 458.4, ADR-073 D12).
//
// Shows only while the tenant has a Pending / Running GL recalculation job of any type (entries-base
// rebuild, revaluation range, balance recalculation). It starts nothing: the click goes to Tools →
// Balance Calculation, where the jobs and their history live. Polling cadence lives in activeRecalcModel.

import React from 'react';
import { Tooltip } from 'antd';
import { RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';
import { activeJobsLabel, describeActiveJob, useActiveRecalcJobs } from './activeRecalcModel';
import styles from './Shell.module.css';

function ActiveRecalcBadge(): React.ReactElement | null {
  const jobs = useActiveRecalcJobs();
  const navigate = useNavigate();
  if (jobs.length === 0) return null;

  const label = activeJobsLabel(jobs.length);
  return (
    <Tooltip
      title={
        <div>
          {jobs.map((job) => (
            <div key={job.jobId}>{describeActiveJob(job)}</div>
          ))}
        </div>
      }
    >
      <button
        type="button"
        className={`${styles.iconButton} ${styles.recalcPill}`}
        onClick={() => navigate(ROUTES.tools.balanceCalculation)}
        aria-label={`${label} — open Balance calculation`}
      >
        <RefreshCw size={14} aria-hidden="true" />
        <span>{label}</span>
      </button>
    </Tooltip>
  );
}

export default ActiveRecalcBadge;
